import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FlowsDisplayGridRowDataFragmentGql } from './FlowsDisplayGridRowDataFragmentGql';

export const DatabaseUpstreamFlowsQueryGql: DocumentNode = gql`
query DatabaseUpstreamFlowsQuery($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  databases(filter: { id: $databaseId }) {
    upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowDataFragment
      }
    }
  }
}
${FlowsDisplayGridRowDataFragmentGql}
`;
